<!--应用场景-->

<template>
    <div class="box">
        <div class="block">
            <div class="title">{{name}}</div>
            <div class="nav">
                <template v-for="(item,index) in data.tab">
                    <span @click='num=index' :class="{'active':(num==index)}">{{item}}</span>
                </template>
            </div>
            <div class="pop">
                <div class="imgBox"><img :src="data.list[num].img" alt=""></div>
                <div class="html">
                    <div class="name">{{data.tab[num]}}</div>
                    <div class="w">{{data.list[num].html}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'index',
    props: ['data','name'],
    data() {
        return {
            num: 0
        }
    }
}
</script>
<style scoped>
.box{
    padding: 80px 0 45px;
    background: url('/data/image/ground/panel_item4_bg.jpg') center;
}
.block{
    width: 1200px;
    margin: 0 auto;
}
.title{
    font-size: 30px;
    font-weight: bolder;
    color: #000;
    text-align: center;
    padding-bottom: 50px;
}
.nav{
    border-bottom: 1px solid #e3e3e3;
    height: 60px;
    line-height: 58px;
    font-size: 14px;
}
.nav span{
    display: inline-block;
    cursor: pointer;
    padding: 0 30px;
}
.nav span:hover,.nav span.active{
    color: #1867dd;
    border-bottom: 1px solid #1867dd;
}
.pop{
    margin-top: 60px;
}
.imgBox img{
    display: block;
    width: 525px;
}
.html{
    padding: 20px 70px;
    line-height: 30px;
}
.name{
    font-size: 16px;
    padding: 20px 0;
    color: #303133;
    font-weight: bolder;
}
.html .w{
    font-size: 14px;
    color: #606266;
}
.pop{
    display: flex;
    background: #fff;
}
</style>